import { useState } from 'react';
import Button from '../../component/Button';
import InputBox from '../../component/InputBox';
import ModalDropdown from '../../component/ModalDropdown';

const ConfirmationModal = ({
  isOpen = false,
  closePopUp,
  title = '',
  description = '',
  successHandler,
  clearHandler,
  nobtnText = '',
  yesbtnText = '',
  textInput = false,
  handleInputChange,
  isManditory = true,
  textlimit,
  limitTrue = false,
}) => {
  const [inputValue, setInputValue] = useState('');

  const handleChange = (e) => {
    let value = e.target.value;

    // If limitTrue is enabled, enforce character limit
    if (limitTrue && textlimit && value.length > textlimit) {
      value = value.slice(0, textlimit);
    }

    const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
    setInputValue(capitalizedValue);
    handleInputChange &&
      handleInputChange({ ...e, target: { ...e.target, value: capitalizedValue } });
  };

  return (
    <div className='relative'>
      <ModalDropdown
        isOpen={isOpen}
        closePopUp={closePopUp}
        boxAlign={'center'}
        className='p-5 !rounded-xl'
      >
        <div className='flex flex-col items-center justify-between py-6 px-4'>
          <div className='font-primaryRegular text-2xl font-[700] text-center text-black-color'>
            {title}
          </div>
          <div className='mt-3 text-black-color text-xl font-[500] whitespace-nowrap'>
            {description}
          </div>

          {textInput && (
            <div className='mt-5 w-full'>
              <div>
                <label className='block font-semibold text-sm text-[#545759] mb-2'>Reason : </label>
              </div>
              <InputBox
                type='textarea'
                value={inputValue}
                onChange={handleChange}
                placeholder='Enter Reason'
                label='Enter Reason'
                hidelabel
                className='text-input w-full'
              />
              {limitTrue && textlimit && (
                <div className='text-right text-sm text-gray-600 -mt-5'>
                  {inputValue.length}/{textlimit}
                </div>
              )}
            </div>
          )}

          <div className='flex items-center justify-center gap-5 mt-5'>
            <Button
              text={nobtnText || 'No'}
              smallBtn
              secondary
              className={'!w-[150px]'}
              onClick={() => clearHandler()}
            />
            <Button
              text={yesbtnText || 'Yes'}
              smallBtn
              className='!w-[150px]'
              disabled={isManditory && textInput ? inputValue?.trim() === '' : false}
              onClick={() => successHandler(inputValue)}
            />
          </div>
        </div>
      </ModalDropdown>
    </div>
  );
};

export default ConfirmationModal;
